export const PRODUCT_LINKS = [
  ["AI updates", "/product/ai-updates", "Draft investor updates from your metrics."],
  ["Deck analytics", "/product/deck-analytics", "Tracked deck links with slide-level engagement."],
  ["Investor portal", "/product/investor-portal", "One place investors read, comment, and catch up."],
  ["Employee equity", "/product/employee-equity", "Private grant pages with vesting and scenarios."],
  ["Sweat equity", "/product/sweat-equity", "Value below-market founder time, with a report."],
  ["Documents & signatures", "/product/documents", "Build, send, and sign deal documents."],
];
export const NAV_GROUPS = [
  { id: "platform", label: "Platform", intro: "Updates, investors, equity, and documents in one workspace.", links: PRODUCT_LINKS },
  { id: "solutions", label: "Solutions", intro: "Built for both sides of the table.", links: [
    ["For founders", "/customers#founders", "Report, raise, and manage ownership."],
    ["For investors", "/product/investor-portal", "Follow the companies you back, free."],
    ["For fund managers", "/fund-managers", "Funds, SPVs, capital calls, and LP reporting."],
    ["For employees", "/tools/option-calculator", "Model what your options could be worth."],
  ] },
  { id: "resources", label: "Resources", intro: "See the real workspace and learn the workflow.", links: [
    ["Product tour", "/tour", "Walk through real TenX demo workspaces."],
    ["Guides", "/guides", "Practical investor relations playbooks."],
    ["Documentation", "/docs", "Getting started, step by step."],
    ["Option calculator", "/tools/option-calculator", "Model an equity scenario, free."],
  ] },
  { id: "company", label: "Company", intro: "Who we are and how we handle your data.", links: [
    ["About TenX", "/about", "Why we built it."], ["Security", "/security", "Access controls, sharing limits, and honest boundaries."],
    ["Careers", "/careers", "Areas where you could contribute."], ["Contact", "/contact", "Plans, procurement, or a question."],
  ] },
];
export const linkId = (href) => href.replace(/^\//, "").replace(/[^a-z0-9]+/g, "-");
